<template>
  <div class="edit-table">
    <!-- <slot name="toolbar"></slot> -->
    <el-row class="margin-bottom" :gutter="20">
      <el-col :span="6" style="margin-bottom: 10px;">
        <el-select clearable v-model="params.businessType" placeholder="业务类型">
          <el-option
            v-for="(item, key) in options"
            :key="key"
            :label="item.dictValue"
            :value="item.dictCode"
          ></el-option>
        </el-select>
      </el-col>

      <el-col :span="6" style="margin-bottom: 10px;">
        <el-input clearable v-model="params.cashDetailId" placeholder="业务编码"> </el-input>
      </el-col>
      <el-col :span="6" style="margin-bottom: 10px;">
        <el-select clearable v-model="params.capitalType" placeholder="资金类型">
          <el-option
            v-for="(item, key) in taxCapitalType"
            :key="key"
            :label="item.dictValue"
            :value="item.dictCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="6" style="margin-bottom: 10px;">
        <el-select clearable v-model="params.detailStatus" placeholder="状态">
          <el-option
            v-for="(item, key) in taxCashDetailStatus"
            :key="key"
            :label="item.dictValue"
            :value="item.dictCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="10">
        <el-date-picker
          clearable
          v-model="dateTime"
          value-format="yyyy-MM-dd"
          @change="handleDataPickerChange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker
      ></el-col>
      <el-col :span="14">
        <div class="flex-end">
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </div>
      </el-col>
    </el-row>
    <vxe-table ref="fineTable" style="width: 100%" :data="fundList">
      <vxe-table-column min-width="120" field="cashDetailId" title="业务编码"></vxe-table-column>
      <vxe-table-column
        min-width="120"
        field="poolAccountDetailCode"
        title="红包池流水编码"
      ></vxe-table-column>
      <vxe-table-column
        min-width="100"
        field="poolAccountCode"
        title="红包池编码"
      ></vxe-table-column>
      <vxe-table-column
        min-width="120"
        field="poolAccountName"
        title="红包池名称"
      ></vxe-table-column>
      <vxe-table-column
        min-width="100"
        field="sourceTypeName"
        title="关联客户名称"
      ></vxe-table-column>

      <!-- <vxe-table-column min-width="100" field="custCode" title="客户编码"></vxe-table-column>  -->
      <vxe-table-column min-width="100" field="businessType" title="业务类型">
        <template #default="{ row }">
          <span v-if="row.businessType === '1'">手动上账</span>
          <span v-if="row.businessType === '2'">红包提现扣减</span>
          <span v-if="row.businessType === '0'">手动扣减</span>
          <span v-if="row.businessType === '9'">基础服务费扣减</span>
        </template>
      </vxe-table-column>
      <vxe-table-column min-width="100" field="capitalType" title="资金类型">
        <template #default="{ row }">
          <span>{{ taxCapitalTypeDict[row.capitalType] }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column min-width="100" field="detailStatus" title="状态">
        <template #default="{ row }">
          <span>{{ taxCashDetailStatusDict[row.detailStatus] }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        min-width="120"
        field="changeAmount"
        title="交易金额（元）"
      ></vxe-table-column>
      <vxe-table-column min-width="100" field="remark" title="备注"></vxe-table-column>
      <vxe-table-column min-width="130" field="createTime" title="创建时间"></vxe-table-column>
    </vxe-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total,prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page="pagination.current"
        :page-size="pagination.pageSize"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import request from '@/found/utils/request';
import elementComponents from './elementComponents';

export default {
  name: 'Payment',
  props: {
    value: Object,
    id: String,
    poolAccountCode: String,
    poolAccountType: String,
  },
  components: {
    ...elementComponents,
  },
  watch: {},
  data() {
    return {
      fundList: [], // 支付明细
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1,
      },
      params: {
        businessType: '',
        startDate: '',
        endDate: '',
      },
      dateTime: [],
      options: [],
      taxCapitalTypeDict: {},
      taxCapitalType: [],
      taxCashDetailStatusDict: {},
      taxCashDetailStatus: [],
    };
  },
  mounted() {
    this.getDict();
    this.getData();
  },
  methods: {
    getDict() {
      request
        .post('/mdm/mdmdictdata/batchDictSelect', [
          'tax_bussiness_type',
          'tax_capital_type',
          'tax_cash_detail_status',
        ])
        .then((res) => {
          this.options = res.result.tax_bussiness_type;
          this.taxCapitalType = res.result.tax_capital_type;
          this.taxCashDetailStatus = res.result.tax_cash_detail_status;
          res.result.tax_capital_type.forEach((d) => {
            this.taxCapitalTypeDict[d.dictCode] = d.dictValue;
          });
          res.result.tax_cash_detail_status.forEach((d) => {
            this.taxCashDetailStatusDict[d.dictCode] = d.dictValue;
          });
        });
    },
    // change分页
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getData();
    },
    async getData() {
      const data = await request
        .post('/tax/v1/redPooolAccount/findDetailByConditions', {
          id: this.id,
          poolAccountCode: this.poolAccountCode,
          poolAccountType: this.poolAccountType,
          pageNum: this.pagination.current,
          pageSize: 20,
          ...this.params,
        })
        .then((res) => (res.success ? res.result : {}));
      this.fundList = data.data || [];
      this.pagination.total = data.count || 0;
    },
    onSubmit() {
      this.getData();
    },
    handleDataPickerChange(e) {
      if (e && e.length) {
        const [startDate, endDate] = e;
        this.params.startDate = startDate;
        this.params.endDate = endDate;
      } else {
        this.params.startDate = '';
        this.params.endDate = '';
      }
    },
    onReset() {
      this.params.businessType = '';
      this.params.endDate = '';
      this.params.endDate = '';
      this.dateTime = [];
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.margin-bottom {
  margin-bottom: 10px;
}
.flex-end {
  display: flex;
  justify-content: flex-end;
}
.edit-table {
  padding-left: 50px;
}
.form-conrtol {
  width: 100%;
}
/deep/ .vxe-body--column {
  height: 50px !important;
}
.pagination {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  color: white !important;
}
</style>
